"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Atmoscoop = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const ResourceType_1 = require("../../ResourceType");
const SelectCard_1 = require("../../inputs/SelectCard");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Card_1 = require("../Card");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
const constants_1 = require("./../../constants");
class Atmoscoop extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.ATMOSCOOP,
            cost: 22,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.SPACE],
            tr: { tr: 2 },
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.SCIENCE, 3)),
            metadata: {
                cardNumber: '217',
                description: 'Requires 3 Science tags. Either raise the temperature 2 steps, or raise Venus 2 steps. Add 2 Floaters to ANY card.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.temperature(2).or(Size_1.Size.SMALL).venus(2).br;
                    b.floaters(2).asterix();
                }),
                victoryPoints: 1,
            },
        });
    }
    canPlay(player) {
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const venusScale = player.game.getVenusScaleLevel();
        const temperature = player.game.getTemperature();
        let trGainFromTemperatureRaise = player.computeTerraformRatingBump(this);
        if (redsAreRuling && (temperature === -4 || temperature === -2))
            trGainFromTemperatureRaise += 1;
        let trGainFromVenusRaise = player.computeTerraformRatingBump(this);
        if (redsAreRuling && (venusScale === 12 || venusScale === 14))
            trGainFromVenusRaise += 1;
        const minTRGain = Math.min(trGainFromTemperatureRaise, trGainFromVenusRaise);
        const maxTRGain = Math.max(trGainFromTemperatureRaise, trGainFromVenusRaise);
        Card_1.Card.setRedsWarningText(player, maxTRGain, this, minTRGain !== maxTRGain);
        if (!super.canPlay(player))
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: minTRGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetailsForRaisingTemperature = this.getActionDetailsForRaisingTemperature(player, this);
            const actionDetailsForRaisingVenus = this.getActionDetailsForRaisingVenus(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetailsForRaisingTemperature, false, true);
            if (this.howToAffordReds.redTaxes === 3 * constants_1.REDS_RULING_POLICY_COST && this.howToAffordReds.canAfford === false) {
                this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetailsForRaisingVenus, false, true);
            }
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        var _a, _b;
        const game = player.game;
        const floaterCards = player.getResourceCards(ResourceType_1.ResourceType.FLOATER);
        if (this.temperatureIsMaxed(game) && this.venusIsMaxed(game) && floaterCards.length === 0) {
            return undefined;
        }
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const venusScale = game.getVenusScaleLevel();
        const venusStepsRaised = Math.min((constants_1.MAX_VENUS_SCALE - venusScale) / 2, 2);
        const increaseVenus = new SelectOption_1.SelectOption('Raise Venus 2 steps', 'Raise venus', () => {
            game.increaseVenusScaleLevel(player, 2);
            game.log('${0} increased Venus ${1} step(s)', (b) => b.player(player).number(venusStepsRaised));
            return undefined;
        });
        let raiseVenusCost = 0;
        if (redsAreRuling) {
            if (venusScale === 12 || venusScale === 14) {
                raiseVenusCost = 3 * constants_1.REDS_RULING_POLICY_COST;
            }
            else {
                raiseVenusCost = venusStepsRaised * constants_1.REDS_RULING_POLICY_COST;
            }
        }
        const temperature = game.getTemperature();
        const temperatureStepsRaised = Math.min((constants_1.MAX_TEMPERATURE - temperature) / 2, 2);
        const increaseTemp = new SelectOption_1.SelectOption('Raise temperature 2 steps', 'Raise temperature', () => {
            game.increaseTemperature(player, 2);
            game.log('${0} increased temperature ${1} step(s)', (b) => b.player(player).number(temperatureStepsRaised));
            return undefined;
        });
        let raiseTemperatureCost = 0;
        if (redsAreRuling) {
            if (temperature === -4 || temperature === -2) {
                raiseTemperatureCost = 3 * constants_1.REDS_RULING_POLICY_COST;
            }
            else {
                raiseTemperatureCost = temperatureStepsRaised * constants_1.REDS_RULING_POLICY_COST;
            }
        }
        const increaseTempOrVenus = new OrOptions_1.OrOptions();
        increaseTempOrVenus.title = 'Choose global parameter to raise';
        if (player.canAfford(raiseTemperatureCost - (((_a = this.howToAffordReds) === null || _a === void 0 ? void 0 : _a.bonusMCFromPlay) || 0)))
            increaseTempOrVenus.options.push(increaseTemp);
        if (player.canAfford(raiseVenusCost - (((_b = this.howToAffordReds) === null || _b === void 0 ? void 0 : _b.bonusMCFromPlay) || 0)))
            increaseTempOrVenus.options.push(increaseVenus);
        const addFloaters = new SelectCard_1.SelectCard('Select card to add 2 floaters', 'Add floaters', floaterCards, (foundCards) => {
            player.addResourceTo(foundCards[0], { qty: 2, log: true });
            return undefined;
        });
        switch (floaterCards.length) {
            case 1:
                player.addResourceTo(floaterCards[0], { qty: 2, log: true });
            case 0:
                if (this.temperatureIsMaxed(game) && this.venusIsMaxed(game))
                    return undefined;
                return increaseTempOrVenus;
            default:
                if (this.temperatureIsMaxed(game) && this.venusIsMaxed(game))
                    return addFloaters;
                increaseTempOrVenus.cb = () => addFloaters;
                return increaseTempOrVenus;
        }
    }
    getVictoryPoints() {
        return 1;
    }
    temperatureIsMaxed(game) {
        return game.getTemperature() === constants_1.MAX_TEMPERATURE;
    }
    venusIsMaxed(game) {
        return game.getVenusScaleLevel() === constants_1.MAX_VENUS_SCALE;
    }
    getActionDetailsForRaisingTemperature(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromTemperatureIncrease(1) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, temperatureIncrease: 2, bonusMegaCredits: bonusMegaCredits });
    }
    getActionDetailsForRaisingVenus(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, venusIncrease: 2 });
    }
}
exports.Atmoscoop = Atmoscoop;
//# sourceMappingURL=Atmoscoop.js.map